import request from "@/util/axios";


const c = 2;//

let readAppkey = function() {
  let appkey = appkey_sd;//默认的

  let query = window.location.search.substring(1);
  let vars = query.split("&");
  for (var i=0;i<vars.length;i++) {
    let pair = vars[i].split("=");
    if(pair[0] == "appkey"){
      return pair[1];
    }
  }
  return appkey;
}

const api_prifix = "/bnu";

export const api_bnu_docDownloadTimes = params => {
  return request({
    url: api_prifix+"/api/doc/save",
    method: "POST",
    data: params
  });
}


export const api_bnu_readVisiteNums = () => {
  return request({
    url: api_prifix+"/api/browser/save",
    method: "POST",
    data: {
      "ip":window.location.hostname,
      "path":"home" //路径或者图层
    }
  });
};

export const api_bnu_getMailCode = params => {
  return request({
    url: api_prifix+"/api/auth/getMailCode",
    method: "POST",
    data: params
  });
};
export const api_bnu_register = params => {
  return request({
    url: api_prifix+"/api/auth/register",
    method: "POST",
    data: params
  });
};


export let api_bnu_getLayerLegends = params => {
  return request({
    url: api_prifix+"/api/style/getStyle",
    method: "get",
    params: params
  });
};


export const api_bnu_login = params => {

  let rUrl = api_prifix+"/api/auth/login"
  console.log("api_bnu_login::params = ",params," &rUrl= ",rUrl);

  return request({
    url:rUrl,
    method: "POST",
    data: params
  });
};

export const api_bnu_sendPasswordRequestLink = params => {
  return request({
    url: api_prifix+"/api/auth/sendPasswordMail",
    method: "POST",
    data: params
  });
};

export const api_bnu_saveNewPassword = params => {
  return request({
    url: api_prifix+"/api/auth/saveNewPassword",
    method: "POST",
    data: params
  });
};

export const api_bnu_submitFeedback = params => {
  return request({
    url: api_prifix+"/api/feedback/save",
    method: "POST",
    data: params
  });
};









/**
 *
   import { bills_list } from "@/api";

   bills_list(params)
     .then(res => {
              console.log("res.data = ", res.data);
              res.data.data.records.forEach(item => {
                this.ordersRecords.push(item);
              });
              this.page = res.data.data.page;
              this.pagesize = res.data.data.size;
              this.total = res.data.data.total;
              this.currentPage = res.data.data.current;
              if (
                res.data.data.records.length == 0 ||
                res.data.data.records.length < this.pagesize
              ) {
                this.finished = true; // 加载结束
              }
              //pageinded 在此处自增+1
              this.currentPage++;
            })
     .catch(() => {
              Notify({ type: "danger", message: "请求失败" });
            });
 * */

//**********************************************************************************************************************
//气象模块接口
export const qx_station_query = params => {
  return request({
    url: "/qxserver/zdha/meteorological/dimStation",
    method: "get",
    params: params
  });
};


//实况降雨 - 06H/24H
export const res_qx_skjy = params => {
  return request({
    url: "/qxserver/zdha/meteorological/queryActualRainFall",
    method: "get",
    params: params
  });
};

//预报降雨
export const res_qx_fcts = params => {

  return request({
    url: "/qxserver/zdha/meteorological/"+params,
    method: "get",
  });
};


//阀室 -实况降雨
export const station_rainfall = params => {
  let appkey = readAppkey();
  params.appkey =appkey;

  return request({
    url: "/qxserver/zdha/meteorological/queryStationRainFall",
    method: "get",
    params
  });
};


/**
 * @description 西气东输 气象提醒模块
 * @author zcg
 * */
export const weather_forecast = params => {

  return request({
    url: "/qxserver/zdha/meteorological/queryMeteorologicalReminder",
    method: "get",
    params
  });
};






















// 保险类商品
export const insurance = params => {
  return request({
    url: "/bxapi/api/insurance/wx/home",
    method: "get",
    params: params
  });
};

// 我的账单
export const getMyBill = params => {
  return request({
    url: "/bxapi/api/SYSEduBill/mobile/list",
    method: "get",
    params: params
  });
};

// 账单详情
export const billDetail = params => {
  return request({
    url: "/bxapi/api/SYSEduBill/mobile/detail",
    method: "get",
    params: params
  });
};

// 用户登录
export const login = openid => {
  return request({
    url: "/wxapi/wxuser/login" + `/${openid}`,
    method: "get"
  });
};

// 用户注册
export const register = data => {
  return request({
    url: "/wxapi/wxuser/register",
    method: "post",
    data
  });
};

// 接口调整
export const getInsuranceData = params => {
  return request({
    url: "/wxapi/insurance/wxHome",
    method: "get",
    params: params
  });
};

//**********************************************************************************************************************
//在线课程类接口
//读取在线课程的Banner
export const oc_banner = () => {
  return request({
    url: "/wxapi/banner/list?category=2",
    method: "get"
  });
};

export const oc_list = params => {
  return request({
    url: "/wxapi/occourse/list",
    method: "get",
    params: params
  });
};

//**********************************************************************************************************************
//我的订单
export const bills_list = params => {
  return request({
    url: "/wxapi/wxuser/userBills",
    method: "get",
    params: params
  });
};



// WEBPACK FOOTER //
// ./src/api/index.js